<template>
  <BrToolBar @search="buscar" :configFilter="configFilter" :addlFilter="addlFilter" :disableLineFilter="false" :defaultFilter="{val: 'teste'}" >
    <BrModalCadastro />
  </BrToolBar>
</template>

<script>
/**
 * MIXIN
 */
import toolbar from '@/views/mixins/toolbar'

export default {
  name: `ToolBarCadastroResultado`,
  mixins: [toolbar],
  components: { 
    BrModalCadastro: () => import('./modalCadastro'),
    BrToolBar: () => import('@/views/components/toolbar')
  }
}
</script>